import { useTheme } from '@mui/material';
import { useDeviceLayout } from './useDeviceLayout';

/** Padrão único para páginas do menu Clínica: lista em cards abaixo de `md`, ajustes de diálogo no `sm`. */
export function useClinicPageBreakpoints() {
  const theme = useTheme();
  const { isMobileSm, isTabletOrDown } = useDeviceLayout();
  return { theme, isMobile: isMobileSm, isTabletOrDown };
}

/**
 * Container padrão das páginas internas — alinhado ao layout da Agenda (sem margem
 * extra do shell; padding mínimo nas bordas).
 */
export const clinicPageContainerSx = {
  px: { xs: 0.75, sm: 1 },
  pt: { xs: 1, sm: 0 },
  pb: { xs: 10, sm: 0 },
  backgroundColor: 'transparent',
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  boxSizing: 'border-box',
};

/** Aliases para Financeiro, Estoque e outros módulos (mesmo comportamento). */
export const usePageBreakpoints = useClinicPageBreakpoints;
export const pageContainerSx = clinicPageContainerSx;

/** Título de página compacto (padrão Atestados — variant h5). */
export const pageTitleSx = {
  fontWeight: 700,
  color: '#0f172a',
  lineHeight: 1.25,
} as const;

/** Subtítulo abaixo do título de página. */
export const pageSubtitleSx = {
  color: '#64748b',
} as const;
